import { Route, Routes } from 'react-router-dom'
import { AppShell } from '@/components/app-shell'
import { DevSwitcher } from '@/components/dev-switcher'
import { AuthGate } from '@/features/auth/auth-gate'
import { LoginPage } from '@/features/auth/login-page'
import { LoginCallbackPage } from '@/features/auth/callback-page'
import { HomePage } from '@/features/home/home-page'
import { OrdersListPage } from '@/features/orders/orders-list-page'
import { OrderDetailPage } from '@/features/orders/order-detail-page'
import { PurchasingListPage } from '@/features/purchasing/purchasing-list-page'
import { PurchasingWizardPage } from '@/features/purchasing/purchasing-wizard-page'
import { PurchasingDetailPage } from '@/features/purchasing/purchasing-detail-page'
import { RequestsListPage } from '@/features/requests/requests-list-page'
import { RequestCreatePage } from '@/features/requests/request-create-page'
import { RequestDetailPage } from '@/features/requests/request-detail-page'
import { QuotesListPage } from '@/features/quotes/quotes-list-page'
import { QuoteDetailPage } from '@/features/quotes/quote-detail-page'
import { InvoicesListPage } from '@/features/invoices/invoices-list-page'
import { InvoiceDetailPage } from '@/features/invoices/invoice-detail-page'
import { AccountPage } from '@/features/account/account-page'
import { CreditPage } from '@/features/credit/credit-page'
import { CreditApplyPage } from '@/features/credit/credit-apply-page'
import { GettingStartedPage } from '@/features/getting-started/getting-started-page'
import { TradeReferencePage } from '@/features/reference/reference-page'
import { IntakePage } from '@/features/intake/intake-page'
import { NotFoundPage } from '@/features/not-found-page'

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/callback" element={<LoginCallbackPage />} />
        {/* Public trade-reference form — the emailed token IS the authorization. */}
        <Route path="/reference/:token" element={<TradeReferencePage />} />
        {/* Public customer-intake form — the welcome-packet link (pre-SAP
            accounts have no Hub login, so the token IS the authorization). */}
        <Route path="/intake/:token" element={<IntakePage />} />

        <Route element={<AuthGate />}>
          <Route element={<AppShell />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/orders" element={<OrdersListPage />} />
            <Route path="/orders/:id" element={<OrderDetailPage />} />
            <Route path="/purchasing" element={<PurchasingListPage />} />
            <Route path="/purchasing/new" element={<PurchasingWizardPage />} />
            <Route path="/purchasing/:id" element={<PurchasingDetailPage />} />
            <Route path="/requests" element={<RequestsListPage />} />
            <Route path="/requests/new" element={<RequestCreatePage />} />
            <Route path="/requests/:id" element={<RequestDetailPage />} />
            <Route path="/quotes" element={<QuotesListPage />} />
            <Route path="/quotes/:id" element={<QuoteDetailPage />} />
            <Route path="/invoices" element={<InvoicesListPage />} />
            <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/getting-started" element={<GettingStartedPage />} />
            <Route path="/credit" element={<CreditPage />} />
            <Route path="/credit/apply" element={<CreditApplyPage />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {/* Mounted outside AuthGate: switching works from /login too, so local
          dev needs no magic-link dance at all. Hidden unless /v1/dev/ping
          answers (the API's local-only switcher surface). */}
      <DevSwitcher />
    </>
  )
}
